export const chaveMaps = 'AIzaSyAhXI6TEeCwqPp3potaizzaRBaXsrp8lwE'
export const chaveGeocoding = 'AIzaSyA4Whzu_gg6Br7jnfP5P1mcFpq83UQW9EM'
